// TODO: Move /api/permissions end-point methods to this class

import { PERMISSIONS } from '@rootCommon/constants/end-points';
import { PermissionsUserAccessResponse } from '@rootTypes/permission-access';
import CrudRequest from './crud-request';

class PermissionsService {
  getUserAccess = async (): Promise<PermissionsUserAccessResponse> => {
    const res = await CrudRequest.get<PermissionsUserAccessResponse>(`${PERMISSIONS}/user-access`);

    return res.data;
  };
}

export default new PermissionsService();
